
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kz1DD", function(module, exports) {
$parcel$export(module.exports, "TransformWrapper", function () { return $ef8858de857ee727$export$51cb649375dcd655; });
$parcel$export(module.exports, "TransformComponent", function () { return $ef8858de857ee727$export$1def2aa75b7c7fe0; });

var $gljCV = parcelRequire("gljCV");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $ef8858de857ee727$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $ef8858de857ee727$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $ef8858de857ee727$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $ef8858de857ee727$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $ef8858de857ee727$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $ef8858de857ee727$var$animations = {
    easeOut: $ef8858de857ee727$var$easeOut,
    linear: $ef8858de857ee727$var$linear,
    easeInQuad: $ef8858de857ee727$var$easeInQuad,
    easeOutQuad: $ef8858de857ee727$var$easeOutQuad,
    easeInOutQuad: $ef8858de857ee727$var$easeInOutQuad,
    easeInCubic: $ef8858de857ee727$var$easeInCubic,
    easeOutCubic: $ef8858de857ee727$var$easeOutCubic,
    easeInOutCubic: $ef8858de857ee727$var$easeInOutCubic,
    easeInQuart: $ef8858de857ee727$var$easeInQuart,
    easeOutQuart: $ef8858de857ee727$var$easeOutQuart,
    easeInOutQuart: $ef8858de857ee727$var$easeInOutQuart,
    easeInQuint: $ef8858de857ee727$var$easeInQuint,
    easeOutQuint: $ef8858de857ee727$var$easeOutQuint,
    easeInOutQuint: $ef8858de857ee727$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $ef8858de857ee727$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $ef8858de857ee727$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $ef8858de857ee727$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $ef8858de857ee727$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $ef8858de857ee727$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $ef8858de857ee727$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $ef8858de857ee727$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $ef8858de857ee727$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $ef8858de857ee727$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $ef8858de857ee727$var$roundNumber(value, 2);
    if (value < minBound) return $ef8858de857ee727$var$roundNumber(minBound, 2);
    if (value > maxBound) return $ef8858de857ee727$var$roundNumber(maxBound, 2);
    return $ef8858de857ee727$var$roundNumber(value, 2);
};
var $ef8858de857ee727$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $ef8858de857ee727$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $ef8858de857ee727$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $ef8858de857ee727$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $ef8858de857ee727$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $ef8858de857ee727$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $ef8858de857ee727$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $ef8858de857ee727$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $ef8858de857ee727$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $ef8858de857ee727$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $ef8858de857ee727$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $ef8858de857ee727$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $ef8858de857ee727$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $ef8858de857ee727$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $ef8858de857ee727$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $ef8858de857ee727$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $ef8858de857ee727$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $ef8858de857ee727$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $ef8858de857ee727$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $ef8858de857ee727$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $ef8858de857ee727$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $ef8858de857ee727$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    $ef8858de857ee727$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $ef8858de857ee727$var$handleTouchPanningSetup(contextInstance, event);
    else $ef8858de857ee727$var$handlePanningSetup(contextInstance, event);
}
function $ef8858de857ee727$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $ef8858de857ee727$var$handlePanToBounds(contextInstance);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $ef8858de857ee727$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $ef8858de857ee727$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $ef8858de857ee727$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $ef8858de857ee727$var$handleVelocityPanning(contextInstance);
        else $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    }
}
function $ef8858de857ee727$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ef8858de857ee727$var$__assign = function() {
    $ef8858de857ee727$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef8858de857ee727$var$__assign.apply(this, arguments);
};
function $ef8858de857ee727$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ef8858de857ee727$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $ef8858de857ee727$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $ef8858de857ee727$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $ef8858de857ee727$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $ef8858de857ee727$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $ef8858de857ee727$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $ef8858de857ee727$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $ef8858de857ee727$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $ef8858de857ee727$var$initialState.positionY
    };
};
var $ef8858de857ee727$var$createSetup = function(props) {
    var newSetup = $ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $ef8858de857ee727$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($ef8858de857ee727$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $ef8858de857ee727$var$__spreadArray($ef8858de857ee727$var$__spreadArray([], $ef8858de857ee727$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $ef8858de857ee727$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $ef8858de857ee727$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $ef8858de857ee727$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $ef8858de857ee727$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $ef8858de857ee727$var$animate(contextInstance, newState, animationTime, animationType);
}
function $ef8858de857ee727$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $ef8858de857ee727$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $ef8858de857ee727$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $ef8858de857ee727$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $ef8858de857ee727$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $ef8858de857ee727$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $ef8858de857ee727$var$calculateZoomToNode(contextInstance, target, scale);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $ef8858de857ee727$var$zoomIn(contextInstance),
        zoomOut: $ef8858de857ee727$var$zoomOut(contextInstance),
        setTransform: $ef8858de857ee727$var$setTransform(contextInstance),
        resetTransform: $ef8858de857ee727$var$resetTransform(contextInstance),
        centerView: $ef8858de857ee727$var$centerView(contextInstance),
        zoomToElement: $ef8858de857ee727$var$zoomToElement(contextInstance)
    };
};
var $ef8858de857ee727$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $ef8858de857ee727$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $ef8858de857ee727$var$getState(contextInstance));
    Object.assign(ref, $ef8858de857ee727$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $ef8858de857ee727$var$passiveSupported = false;
function $ef8858de857ee727$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $ef8858de857ee727$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $ef8858de857ee727$var$passiveSupported = false;
        return $ef8858de857ee727$var$passiveSupported;
    }
}
var $ef8858de857ee727$var$matchPrefix = ".".concat($ef8858de857ee727$var$baseClasses.wrapperClass);
var $ef8858de857ee727$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, " *, ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $ef8858de857ee727$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $ef8858de857ee727$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $ef8858de857ee727$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $ef8858de857ee727$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $ef8858de857ee727$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $ef8858de857ee727$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $ef8858de857ee727$var$getDelta(event, customDelta) {
    var deltaY = $ef8858de857ee727$var$getDeltaY(event);
    var delta = $ef8858de857ee727$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $ef8858de857ee727$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $ef8858de857ee727$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $ef8858de857ee727$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $ef8858de857ee727$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $ef8858de857ee727$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $ef8858de857ee727$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $ef8858de857ee727$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $ef8858de857ee727$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $ef8858de857ee727$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $ef8858de857ee727$var$wheelStopEventTime = 160;
var $ef8858de857ee727$var$wheelAnimationTime = 100;
var $ef8858de857ee727$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStart);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $ef8858de857ee727$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $ef8858de857ee727$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $ef8858de857ee727$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheel);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
};
var $ef8858de857ee727$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $ef8858de857ee727$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $ef8858de857ee727$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStop);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
        }, $ef8858de857ee727$var$wheelStopEventTime);
    }
};
var $ef8858de857ee727$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $ef8858de857ee727$var$handlePinchStart = function(contextInstance, event) {
    var distance = $ef8858de857ee727$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
};
var $ef8858de857ee727$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $ef8858de857ee727$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $ef8858de857ee727$var$getTouchDistance(event);
    var newScale = $ef8858de857ee727$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $ef8858de857ee727$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $ef8858de857ee727$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $ef8858de857ee727$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $ef8858de857ee727$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    });
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
};
function $ef8858de857ee727$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $ef8858de857ee727$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $ef8858de857ee727$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $ef8858de857ee727$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
}
var $ef8858de857ee727$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $ef8858de857ee727$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($ef8858de857ee727$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($ef8858de857ee727$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $ef8858de857ee727$var$handleWheelStart(_this, event);
            $ef8858de857ee727$var$handleWheelZoom(_this, event);
            $ef8858de857ee727$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $ef8858de857ee727$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $ef8858de857ee727$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $ef8858de857ee727$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handlePanningStart(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePanning(_this, event.clientX, event.clientY);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $ef8858de857ee727$var$handlePanningEnd(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handlePinchStart(_this, event);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStart);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePinchZoom(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinching);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $ef8858de857ee727$var$handlePinchStop(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStop);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (!isDoubleTap) {
                _this.lastTouch = +new Date();
                $ef8858de857ee727$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $ef8858de857ee727$var$handleCancelAnimation(_this);
                    $ef8858de857ee727$var$handlePanningStart(_this, event);
                    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $ef8858de857ee727$var$handlePanning(_this, touch.clientX, touch.clientY);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $ef8858de857ee727$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $ef8858de857ee727$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $ef8858de857ee727$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $ef8858de857ee727$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $ef8858de857ee727$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $ef8858de857ee727$var$getContext(_this);
            $ef8858de857ee727$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $ef8858de857ee727$var$createSetup(this.props);
        this.transformState = $ef8858de857ee727$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $ef8858de857ee727$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createContext(null);
var $ef8858de857ee727$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $ef8858de857ee727$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).forwardRef(function(props, ref) {
    var instance = (0, $gljCV.useRef)(new $ef8858de857ee727$var$ZoomPanPinch(props)).current;
    var content = $ef8858de857ee727$var$getContent(props.children, $ef8858de857ee727$var$getControls(instance));
    (0, $gljCV.useImperativeHandle)(ref, function() {
        return $ef8858de857ee727$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $gljCV.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement($ef8858de857ee727$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $ef8858de857ee727$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).forwardRef(function(props, ref) {
    var localRef = (0, $gljCV.useRef)(null);
    var instance = (0, $gljCV.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    (0, $gljCV.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", $ef8858de857ee727$var$__assign({}, props, {
        ref: $ef8858de857ee727$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $ef8858de857ee727$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $ef8858de857ee727$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $gljCV.useRef)();
    var rectRef = (0, $gljCV.useRef)($ef8858de857ee727$var$initialElementRect);
    var didUnmount = (0, $gljCV.useRef)(false);
    (0, $gljCV.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ef8858de857ee727$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $ef8858de857ee727$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $ef8858de857ee727$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $ef8858de857ee727$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $gljCV.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $ef8858de857ee727$export$1708b11af87412f8();
    var miniMapInstance = (0, $gljCV.useRef)(null);
    var mainRef = (0, $gljCV.useRef)(null);
    var wrapperRef = (0, $gljCV.useRef)(null);
    var previewRef = (0, $gljCV.useRef)(null);
    var getViewportSize = (0, $gljCV.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $gljCV.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $gljCV.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $ef8858de857ee727$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $ef8858de857ee727$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $ef8858de857ee727$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $gljCV.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $gljCV.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $ef8858de857ee727$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $ef8858de857ee727$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $ef8858de857ee727$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$ef8858de857ee727$var$styleInject($ef8858de857ee727$var$css_248z);
var $ef8858de857ee727$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $gljCV.useContext)($ef8858de857ee727$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $gljCV.useRef)(null);
    var contentRef = (0, $gljCV.useRef)(null);
    (0, $gljCV.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", $ef8858de857ee727$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.wrapperClass, " ").concat($ef8858de857ee727$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement("div", $ef8858de857ee727$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.contentClass, " ").concat($ef8858de857ee727$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $ef8858de857ee727$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $gljCV.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $ef8858de857ee727$export$8a75c83865bcf9dd = function() {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    return $ef8858de857ee727$var$getControls(libraryContext);
};
var $ef8858de857ee727$export$e14839139473133b = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $gljCV.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($ef8858de857ee727$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $ef8858de857ee727$export$769cca75086a299c = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $gljCV.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $ef8858de857ee727$export$4915c4f91c47b682(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    var _a = (0, $gljCV.useState)(callback($ef8858de857ee727$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $gljCV.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($ef8858de857ee727$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}

});

parcelRegister("gRDcE", function(module, exports) {
$parcel$export(module.exports, "ZoomIn", function () { return $e28c461dfd89186d$export$d13069184bfa0730; });

var $dypTs = parcelRequire("dypTs");
const $e28c461dfd89186d$export$d13069184bfa0730 = ({ size: size })=>/*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        id: "icon-content-zoom in",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.65,45.65 L44.6,38.7 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M26.23,0.18 C40.72,0.18 52.46,11.93 52.46,26.42 C52.46,40.9 40.72,52.65 26.23,52.65 C11.74,52.65 0,40.9 0,26.42 C0,11.93 11.74,0.18 26.23,0.18 Z M46.97,26.42 C46.97,37.87 37.69,47.16 26.23,47.16 C14.78,47.16 5.49,37.87 5.49,26.42 C5.49,14.96 14.78,5.67 26.23,5.67 C37.69,5.67 46.97,14.96 46.97,26.42 Z"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M26.54,14.52 C28.05,14.52 29.28,15.75 29.28,17.26 L29.28,23.97 L35.99,23.97 C37.51,23.97 38.74,25.2 38.74,26.72 C38.74,28.24 37.51,29.46 35.99,29.46 L29.28,29.46 L29.28,36.18 C29.28,37.69 28.05,38.92 26.54,38.92 C25.02,38.92 23.79,37.69 23.79,36.18 L23.79,29.46 L17.08,29.46 C15.56,29.46 14.34,28.24 14.34,26.72 C14.34,25.2 15.56,23.97 17.08,23.97 L23.79,23.97 L23.79,17.26 C23.79,15.75 25.02,14.52 26.54,14.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("yKFYG", function(module, exports) {
$parcel$export(module.exports, "ZoomOut", function () { return $0b44293d87c575f9$export$adc4acb67269225; });

var $dypTs = parcelRequire("dypTs");
const $0b44293d87c575f9$export$adc4acb67269225 = ({ size: size })=>/*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        id: "icon-content-zoom out",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("dmI5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9baf86847fb0b0d5$var$_react = $9baf86847fb0b0d5$var$_interopRequireDefault((parcelRequire("gljCV")));

var $9baf86847fb0b0d5$var$_baseNew = $9baf86847fb0b0d5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9baf86847fb0b0d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9baf86847fb0b0d5$var$DecisionIcon = (props)=>/*#__PURE__*/ $9baf86847fb0b0d5$var$_react.default.createElement($9baf86847fb0b0d5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$9baf86847fb0b0d5$var$DecisionIcon.displayName = 'DecisionIcon';
var $9baf86847fb0b0d5$var$_default = module.exports.default = $9baf86847fb0b0d5$var$DecisionIcon;

});

parcelRegister("b0jeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $802e9ccbe48cbd7f$var$_react = $802e9ccbe48cbd7f$var$_interopRequireDefault((parcelRequire("gljCV")));

var $802e9ccbe48cbd7f$var$_baseNew = $802e9ccbe48cbd7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $802e9ccbe48cbd7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $802e9ccbe48cbd7f$var$FilesIcon = (props)=>/*#__PURE__*/ $802e9ccbe48cbd7f$var$_react.default.createElement($802e9ccbe48cbd7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$802e9ccbe48cbd7f$var$FilesIcon.displayName = 'FilesIcon';
var $802e9ccbe48cbd7f$var$_default = module.exports.default = $802e9ccbe48cbd7f$var$FilesIcon;

});


//# sourceMappingURL=confluence-template-category-page.ec440500.js.map
